import React from "react";
import { BookOpenIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  SpeakerWaveIcon,
  EllipsisHorizontalCircleIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

const DoorBuzzerCard = ({
  doorBuzzer,
  isEditState,
  onClickView,
  onClickEdit,
  onClickDelete,
  hasDeletePermission,
}) => {
  return (
    <>
      <div className="bg-white  border border-gray-200 shadow-md  rounded-md">
        <div className="flex w-full p-2 gap-x-2">
          <div className="translate-y-4">
            {" "}
            <SpeakerWaveIcon className="text-blue-500 h-6 w-6" />
          </div>
          <div className="w-full truncate">
            <div className="flex flex-row ">
              <h3 className="text-xs1 items-center flex font-normal text-gray-400">
                <svg
                  className={
                    doorBuzzer.isActive === true
                      ? "text-green-500 mr-1 talic h-2 w-2"
                      : "text-gray-40 -ml-0.5 mr-1 talic h-2 w-2"
                  }
                  fill="currentColor"
                  viewBox="0 0 8 8"
                >
                  <circle cx={4} cy={4} r={3} />
                </svg>{" "}
                {doorBuzzer.isActive === true ? "Active" : "Inactive"}
              </h3>
            </div>
            <div
              onClick={() => {
                onClickView();
              }}
              className={`text-gray-600 font-medium flex flex-row justify-between blueAndBold ${
                isEditState ? "" : "cursor-pointer"
              }`}
            >
              <h1 className="mr-auto truncate text-ellipsis font-bold text-quinary text-base underline uppercase">
                {doorBuzzer.siteNumber
                  ? doorBuzzer.siteNumber
                  : "No Site Number"}{" "}
                {doorBuzzer.connection
                  ? doorBuzzer.connection
                  : "No Connection"}{" "}
                {doorBuzzer.type ? doorBuzzer.type : "No Type"}
              </h1>
            </div>
            <h2 className="text-xxs  text-gray-600 truncate">
              {doorBuzzer.dbinstallDate
                ? new Date(doorBuzzer.dbinstallDate)?.toLocaleDateString()
                : "No Install Date"}
            </h2>
            <div className="text-xxs  text-gray-600 truncate">
              {doorBuzzer.dbinstallVendorName
                ? doorBuzzer.dbinstallVendorName
                : "No Vendor"}
              {"-"}
              {doorBuzzer.dbwarrantyVendorName
                ? doorBuzzer.dbwarrantyVendorName
                : "No Vendor"}
              {"-"}
              {doorBuzzer.dbservicingVendorName
                ? doorBuzzer.dbservicingVendorName
                : "No Vendor"}
            </div>
          </div>
          {isEditState && (
            <div className="flex justify-end w-25">
              <Menu as="div" className="flex">
                <div>
                  <Menu.Button className="">
                    <EllipsisHorizontalCircleIcon
                      className="h-4 w-4 text-primary rounded-full hover:bg-primary hover:text-white "
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute z-50 mt-2 w-24 origin-top-right divide-y divide-gray-100 rounded-md   bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1">
                      {isEditState && (
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              className={""}
                              onClick={() => {
                                onClickEdit();
                              }}
                              disabled={false}
                            >
                              <label className="flex flex-cols underline cursor-pointer text-quaternary text-xs fontLabel font-semibold ">
                                {" "}
                                <PencilSquareIcon className="h-4 w-4  text-quaternary" />{" "}
                                Edit
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      )}
                    </div>
                    <div className="px-1 py-1">
                      {hasDeletePermission && doorBuzzer.isActive === true && (
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              className={""}
                              onClick={() => {
                                onClickDelete();
                              }}
                              disabled={false}
                            >
                              <label className="flex flex-cols underline cursor-pointer text-secondary text-xs fontLabel font-semibold ">
                                {" "}
                                <TrashIcon className="h-4 w-4 text-secondary" />{" "}
                                Deactivate
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      )}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DoorBuzzerCard;
